import React, { useEffect, useState } from "react";
import "./DraftSurveys.scss";
import { Button, Select } from "components/form";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getFromLocal } from "config/axiosInstance";
import { surveyListApi } from "services/survey";
import useDebounce from "hooks/useDebounce";
import { toastMessage } from "utils/toastMessageHelper";
import useShimmer from "hooks/useShrimmer";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import {
  decryptData,
  handleDecryptionParams,
  handleEncryptionParams,
} from "utils/dataCipherHelper";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import { surveyPlaceholderImg } from "assets/images";

const DraftSurveys = () => {
  //************************** Handle all state ***************************//

  const navigate = useNavigate();

  const [myDraftListing, setMyDraftListing] = useState([]);
  const [draftTotalRecord, setDraftTotalRecord] = useState(0);

  // Handle all filter state
  const [searchValue, setSearchValue] = useState("");
  const searchDebouncedValue = useDebounce(searchValue, 300);

  const [searchParams, setSearchParams] = useSearchParams();

  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);

  //************************* Handle all function *************************//

  // function for get draft list
  const getDraftListHandler = async () => {
    try {
      setShowShimmer(true);
      const reqData = {
        search: searchValue,
        surveyStatus: "draft",
        token: getFromLocal(),
      };

      if (searchValue && searchDebouncedValue) {
        reqData.search = searchDebouncedValue;
      }

      const responseData = await surveyListApi(reqData);
      const {
        data: { surveyList = [], total = 0 },
        message = "",
        status,
      } = responseData;

      if (status === 200) {
        // if (Number(surveyActivePage) === 1) {
        setMyDraftListing(surveyList);
        // toastMessage(message, "success", "SurveyList");
        // } else {
        //   setSurveyList((prevList) => [...prevList, ...surveyList]);
        // }

        setDraftTotalRecord(total);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // useEffect for get draft list
  useEffect(() => {
    getDraftListHandler();

    // eslint-disable-next-line
  }, []);

  // Function for re-direct on survey page
  const reDirectHandler = (data) => {
    const paramsData = {
      stepper: 3,
      isDraft: true,
      surveyId: data?._id,
    };
    const encryptedParams = handleEncryptionParams(paramsData, searchParams);

    // return;
    setSearchParams(encryptedParams);
    navigate(`/dashboard/create-survey?${encryptedParams}`);
  };

  //******************************** Handle ALL HTML CODE ******************************//
  return (
    <>
      <div className="draft_surveysList">
        <div className="has_child">
          <h3 className="dashboard_title">My Drafts</h3>
          <Select>
            <option>Filter By</option>
            <option>Filter By</option>
          </Select>
        </div>

        {showShimmer || (
          <div className="card_wrap">
            {myDraftListing?.length > 0 ? (
              myDraftListing?.map((item, ind) => (
                <div key={item?._id} className="template_card">
                  <div className="card_header">
                    <span>{item?.surveyReferenceNumber || "-----"}</span>
                    <h4>{item?.title || "-----"}</h4>
                  </div>
                  <div className="card_body">
                    <Button
                      className="button"
                      onClick={() => reDirectHandler(item)}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <NotFoundPlaceHolder
                className="mySurveyList"
                title="Draft list not found"
                placeHolderImage={surveyPlaceholderImg}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default DraftSurveys;
